// import './plugins/gtag'
import './plugins/gtag'
import './plugins/vuetify'
import './assets/stylus/main.styl'

import PortalVue, { Portal, PortalTarget } from 'portal-vue'
import Vue from 'vue'

import router from '@/router'
import CareshipTracking from '@/sdk/careshipTracking'
import store from '@/store'

import ClickOutside from '@/directives/click-outside'
import App from './App.vue'
import appLoader from './appLoader'
import BookingFunnelLayout from './layout/bookingFunnel.vue'
import DashboardLayout from './layout/dashboard.vue'
import MainLayout from './layout/main.vue'
import WideLayout from './layout/wide.vue'
import BookingStatusLayout from './layout/bookingStatus.vue'
import EmptyLayout from './layout/empty.vue'
import Translate from './plugins/translatePlugin'
import logger from './sdk/logger'

// Define `portal-target`/`portal` tag only to make IDEA IDEs aware of it

Vue.component('portal-target', PortalTarget)
Vue.component('portal', Portal)
Vue.component('main-layout', MainLayout)
Vue.component('booking-funnel-layout', BookingFunnelLayout)
Vue.component('wide-layout', WideLayout)
Vue.component('dashboard-layout', DashboardLayout)
Vue.component('booking-status-layout', BookingStatusLayout)
Vue.component('empty-layout', EmptyLayout)
Vue.directive('click-outside', ClickOutside)

Vue.config.productionTip = false
Vue.config.errorHandler = (error, _, errorInfo) => {
  // noinspection JSIgnoredPromiseFromCall
  logger.warn('Uncaught error on vue global errorHandler', {
    error,
    tags: ['global'],
    additionalData: {
      errorInfo,
    },
  })

  throw error
}

Vue.use(PortalVue)
Vue.use(Translate)
Vue.use(CareshipTracking, { router })
// Vue.use(VueAnalytics, {
//   id: 'G-V8WDGHQ0HC',
//   router,
// })

window.onerror = function errorHandler(
  errorMessage,
  errorUrl,
  errorLine,
  errorCol,
  error,
) {
  // noinspection JSIgnoredPromiseFromCall
  logger.warn('Uncaught error on window global errorHandler', {
    error,
    tags: ['global'],
    additionalData: {
      errorMessage,
      errorUrl,
      errorLine,
      errorCol,
    },
  })

  throw error
}

export const eventBus = new Vue()

appLoader(() => {
  new Vue({
    router,
    store,
    render: h => h(App),
  }).$mount('#app')
})
